<!--загрузка данных  -->
<script src="https://kit.fontawesome.com/a5aa9bda3c.js" crossorigin="anonymous"></script>
<router-outlet></router-outlet>